import { render, staticRenderFns } from "./SetupTemplateTestsType.vue?vue&type=template&id=fbf3424c&"
import script from "./SetupTemplateTestsType.vue?vue&type=script&lang=js&"
export * from "./SetupTemplateTestsType.vue?vue&type=script&lang=js&"
import style0 from "./SetupTemplateTestsType.vue?vue&type=style&index=0&id=fbf3424c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports